import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { Pagination } from '../../stores/core/models';
import { useCoreStore } from '../../stores/core/store';
import { ResolveDrawerParams } from '../models/routing';
import { getPaginationBasedOnUserPreferences } from 'src/core/utils/user-preferences-utils';
import useRouteResolverUserPreferences from '@/core/router-utils/route-resolver-user-preferences';

export default () => {
  const route = useRoute();
  const { drawerContainerData } = storeToRefs(useCoreStore());
  const { updateResolveDrawerParamsBasedOnUserPreferences } = useRouteResolverUserPreferences();

  const resolveDrawerData = (resolveDrawerParams: ResolveDrawerParams): Promise<any> => {
    //const pagination = { ...resolveDrawerParams.resolveParams.pagination };
    updateResolveDrawerParamsBasedOnUserPreferences(resolveDrawerParams);

    // if (!resolveDrawerParams.resolveParams.pagination) {
    //   resolveDrawerParams.resolveParams.pagination = {
    //     ...getPaginationBasedOnUserPreferences(getDrawerPaginationPreferenceKey(resolveDrawerParams.idDrawer)),
    //     page: 1,
    //   } as Pagination;
    // }

    // if (!resolveDrawerParams.resolveParams.useStoreData && resolveDrawerParams.resolveParams.pagination) {
    //   resolveDrawerParams.resolveParams.pagination.page = pagination.page || 1;
    //   //resolveDrawerParams.resolveParams.pagination.rowsPerPage = pagination.rowsPerPage || 6;
    // }

    resolveDrawerParams.resolveParams.params = route.params;

    return resolveDrawerParams
      .resolveStoreAction(resolveDrawerParams.resolveParams)
      .then(() => (drawerContainerData.value.resolveDrawerParams = resolveDrawerParams));
  };

  return {
    resolveDrawerData,
  };
};
